/**
 * name 媒体实验室左侧菜单栏
 * author zhang.yingyu
 * createTime 2019-05-14
 **/
"use strict";
"use strict";
angular.module("mediaLaboratoryLeftModule", []).
directive("mediaLaboratoryLeft", ["$state", "$timeout", function($state, $timeout) {
    return {
        restrict: "E",
        replace: true,
        templateUrl: "./planningCenter/mediaLaboratory/left/left_tpl.html",
        scope: {
            selected: "="
        },
        link: function(scope, $elem, $attrs) {
            initStatus();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    expanded: false,
                    expandedLeve2: ""
                };
                autoLocation()
            }

            function autoLocation() {
                scope.$watch("selected", (newV, oldV) => {
                    if (newV === "medialaboratory") {
                        scope.status.expanded = true;
                        let routerName = $state.current.name;
                        let routerArray = routerName.split(".");
                        if ($state.current.name != "front.plan.medialaboratory") {
                            scope.status.expandedLeve2 = routerArray[3];
                            scope.$root.narrowNavigation = true;
                        }
                    } else {
                        scope.status.expandedLeve2 = "";
                    }
                });
            }
            /**
             * [selectLeve2 description] 选中二级
             * @param  {[type]} routerNamePart [description] 路由名称
             * @return {[type]}            [description]
             */
            scope.selectLeve2 = function(routerNamePart) {
                scope.status.expandedLeve2 = routerNamePart;
                $state.go("front.plan.medialaboratory." + routerNamePart, "", { reload: "front.plan.medialaboratory." + routerNamePart });
                scope.$root.narrowNavigation = true;
                if (scope.selected !== "medialaboratory") {
                    $timeout(() => {
                        scope.selected = "medialaboratory";
                    }, 500);
                }
            };
        }
    };
}]);